export const ROBOT_PART_REMOVE_CANCEL = 'ROBOT_PART_REMOVE_CANCEL';

export const removeRobotPartCancel = () => ({
  type: ROBOT_PART_REMOVE_CANCEL,
});
